import { useCallback, useEffect, useState } from 'react'

interface UseScrollOptions {
  container?: HTMLElement | Window | null
  threshold?: number
}

export function useScroll({
  container = document.getElementById('root'),
  threshold = 300,
}: UseScrollOptions = {}) {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    if (!container) return

    let timeoutId: NodeJS.Timeout

    const toggleVisibility = () => {
      clearTimeout(timeoutId)

      timeoutId = setTimeout(() => {
        const scrollTop =
          container instanceof Window ? window.scrollY : container.scrollTop
        setIsVisible(scrollTop > threshold)
      }, 16)
    }

    container.addEventListener('scroll', toggleVisibility, {
      passive: true,
    })

    return () => {
      container.removeEventListener('scroll', toggleVisibility)
      clearTimeout(timeoutId)
    }
  }, [container, threshold])

  const scrollToTop = useCallback(() => {
    if (!container) return

    container.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }, [container])

  return { isVisible, scrollToTop }
}
